module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('md-sidenav', {
    ref: "collaboratorsNav",
    staticClass: "md-left collaboratorsNav"
  }, [_c('md-toolbar', {
    staticClass: "md-dense main-toolbar"
  }, [_c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": function($event) {
        _vm.back()
      }
    }
  }, [_c('md-icon', [_vm._v("menu")])], 1), _vm._v(" "), _c('h3', {
    staticClass: "md-title"
  }, [_vm._v("Collaborators")])], 1), _vm._v(" "), _c('md-list', {
    staticClass: "md-double-line"
  }, [_c('md-subheader', [_vm._v("Current Collaborators")]), _vm._v(" "), (_vm.owner) ? _c('md-list-item', [_c('md-avatar', [(_vm.owner.profile_picture) ? _c('img', {
    attrs: {
      "src": _vm.owner.profile_picture,
      "alt": "People"
    }
  }) : _c('img', {
    attrs: {
      "src": require('../../assets/img/silhouette.jpg'),
      "alt": "People"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "md-list-text-container collaborator-text-container"
  }, [_c('span', [_c('strong', [_vm._v(_vm._s(_vm.owner.username))])]), _vm._v(" "), _c('span', [_vm._v("Project Owner")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.owner.email))])])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.collaborators), function(collab) {
    return _c('collaborator', {
      key: collab.id,
      attrs: {
        "user": _vm.user,
        "collabUser": _vm.userByUID(collab.uid),
        "collaborator": collab,
        "editable": _vm.user.uid === _vm.owner.uid,
        "layers": _vm.layers
      },
      on: {
        "removeCollaborator": _vm.removeCollaborator
      }
    })
  })], 2), _vm._v(" "), _c('md-list', {
    staticClass: "md-double-line pendingCollaboratorList"
  }, [_c('md-subheader', [_vm._v("Pending Collaborators")]), _vm._v(" "), _vm._l((_vm.pendingCollaborators), function(collab) {
    return _c('pendingCollaborator', {
      key: collab.id,
      attrs: {
        "collaborator": collab,
        "editable": _vm.user.uid === _vm.owner.uid
      },
      on: {
        "removePendingCollaborator": _vm.removePendingCollaborator
      }
    })
  })], 2), _vm._v(" "), _c('md-list', [(_vm.canEdit) ? _c('invite', {
    attrs: {
      "project": _vm.project
    },
    on: {
      "addCollaborator": _vm.addCollaborator
    }
  }) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b6c6d57e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sample/components/collaborators/nav.vue
// module id = 677
// module chunks = 2